import axios from '../assets/axios'
import { removeKey } from '../assets/utils'

export default {
  namespaced: true,

  state: {
    loanParameter: {}, // 借款要素
    withdrawForm: {
      applyAmt: 0, // 贷款金额
      applyTerm: 0, // 申请期限
      bankCardNo: '', // 放款银行卡号
      purpose: '', // 贷款用途
      repayMethod: '' // 还款方式
    }, // 提现表单
    fundData: { // 资金方数据
      fundAccessCd: '', // 资方准入代码
      fundPartnerCdList: [], // 资金合作方代码
      fundPlanCd: '', // 资金计划代码
      fundProductCd: '' // 资方产品代码
    },
    customerServicePhone: '',
    signedContracts: [] // 合同
  },

  mutations: {
    // 设置借款要素
    setLoanParameter (state, parameter) {
      state.loanParameter = parameter
    },

    // 设置提现表单
    setWithdrawForm (state, params) {
      Object.keys(params).forEach(key => {
        state.withdrawForm[key] = params[key]
      })
    },

    getPhone (state, data) {
      state.customerServicePhone = data
    },

    // 清空提现表单
    clearWithdrawForm (state) {
      state.withdrawForm.applyAmt = 0
      state.withdrawForm.applyTerm = 0
      state.withdrawForm.bankCardNo = ''
      state.withdrawForm.purpose = ''
      state.withdrawForm.repayMethod = ''
      removeKey('withdrawForm')
    },

    SET_SIGNED_CONTRACTS (state, data) {
      state.signedContracts = data
    }
  },

  actions: {
    // 获取借款要素
    getLoanParameterX: ({ commit }, params) => {
      return axios.post('/order/v1/parameter', params)
        .then(response => {
          if (response.data.code === 'OK') {
            commit('setLoanParameter', response.data.data)
          }
          return response.data
        })
    },

    getLoanResultX: ({ commit }, params) => {
      return axios.post('/loan/v1/result', params)
        .then(response => {
          return response.data
        })
    },

    // 查询借款试算接口
    async getLoanTrialX ({ commit }, params) {
      const response = await axios.post('/trail/v1/apply', params)
      return response.data
    },

    // 查询当前用户是否可借款
    async canLoanX ({ commit }, params) {
      const response = await axios.post('/loan/v1/canLoan', params)
      return response.data
    },
    // 查询当前用户是否可借款
    async amtProductX ({ commit }, params) {
      const response = await axios.post('/loan/v1/amt-product', params)
      return response.data
    },

    // 资金路由
    async getFundRouteX ({ commit }, params) {
      const response = await axios.post('/fund/v1/route', params)
      return response.data
    },

    // 检查基本资料字段是否缺失
    async judgeMissingX ({ commit }, params) {
      const response = await axios.post('/user/v2/checkBaseInfo', params)
      return response.data
    },

    // 用户借款申请
    async loanApplyX ({ commit }, params) {
      const response = await axios.post('/loan/v1/apply', params)
      return response.data
    },
    // 用于协议数据填充留资料
    async preLoanApplyX ({ commit }, params) {
      const response = await axios.post('/loan/v1/preApply', params)
      return response.data
    },

    // 用户借款申请2
    async loanApply2X ({ commit }, params) {
      const response = await axios.post('/loan/v1/applyForPrg', params)
      return response.data
    },

    // 用户借款确认
    async loanConfirmX ({ commit }, params) {
      const response = await axios.post('/loan/v1/confirm', params)
      return response.data
    },
    // 用户借款确认2
    async loanConfirm2X ({ commit }, params) {
      const response = await axios.post('/loan/v1/confirmForPrg', params)
      return response.data
    },
    // 最大提现金额判断
    async getMaxLimit ({ commit }, params) {
      const response = await axios.post('/loan/v1/shouldPop', params)
      return response.data
    },
    // 放弃排队
    async giveUpQueuinig ({ commit }, params) {
      const response = await axios.post('/loan/v1/giveUpQueuinig', params)
      return response.data
    },
    // 提现购买VIP排队页面
    async waitVip ({ commit }, params) {
      const response = await axios.post('/loan/v1/waitVip', params)
      return response.data
    },
    // svip 借款申请输入金额页面
    async loanAmountPage ({ commit }, params) {
      const response = await axios.post('/svip/v1/loanAmountPage', params)
      return response.data
    },
    // svip 借款申请 引导页
    async loanGuidPage ({ commit }, params) {
      const response = await axios.post('/svip/v1/loanGuidePage', params)
      return response.data
    },
    // 提现中间等待界面接口
    async couponAttr ({ commit }, params) {
      const response = await axios.post('/svip/v1/couponAttr', params)
      return response.data
    },
    // svip买成功后发送短信接口
    async buySuccess ({ commit }, params) {
      const response = await axios.post('/svip/v1/buySuccess', params)
      return response.data
    },
    // -查看计算器接口
    async compareSvipCommon ({ commit }, params) {
      const response = await axios.get('/svip/v1/compare-svip-common', params)
      return response.data
    },
    // - 我要提现页面-悬浮猫
    async suspendedCat ({ commit }, params) {
      const response = await axios.get('/svip/v1/suspended-cat', { method: 'get', params })
      return response.data
    },
    // - 用户开卡引导
    async buySvipPopup ({ commit }, params) {
      const response = await axios.get('/svip/v1/buy-svip-popup', { method: 'get', params })
      return response.data
    },
    // - 我要提现-svip引导弹窗
    async svipGuidePopup ({ commit }, params) {
      const response = await axios.get('/svip/v1/svip-guide-popup', params)
      return response.data
    },
    // pass卡提现拒绝详情
    async passCardRefusedDetail ({ commit }, params) {
      const response = await axios.post('/pass/v1/loanFailDetail', params)
      return response.data
    },
    // pass卡直供流程标记
    async passDirectMarkTag ({ commit }, params) {
      const response = await axios.post('/tag/v1/passDirectMarkTag', params)
      return response.data
    },
    // 借款申请流程查询，该笔申请所处流程
    async loanApplyProcessX ({ commit }, params) {
      const response = await axios.post('/loan/v1/loanApplyProcess', params)
      return response.data
    },
    async guideApplyX ({ commit }, params) {
      const response = await axios.post('/trail/v1/guideTrial', params)
      return response.data
    },
    async guideLoanApplyX ({ commit }, params) {
      const response = await axios.post('/loan/v1/guideApply', params)
      return response.data
    },
    // 查询借款试算初始配置
    async getLoanTrialXInitConfig ({ commit }, params) {
      const response = await axios.post('/trail/v1/initTrial', params)
      return response.data
    },
    async getLoanDetentionPopType ({ commit }, params) {
      const response = await axios.post('/loan/v1/popType', params)
      return response.data
    },
    async subscriptX ({ commit }, params) {
      const response = await axios.post('/loan/v1/subscript', params)
      return response.data
    },
    // 业务提额流程试算（假提额）
    async getBizLimitUpLoanTrial ({ commit }, params) {
      const response = await axios.post('/trail/v1/bizAdjustAmountTrial', params)
      return response.data
    },
    // 业务提额申请确认（假提额流程）
    async bizLimitUpConfirm ({ commit }, params) {
      const response = await axios.post('/loan/v1/bizAdjustAmountConfirm', params)
      return response.data
    },
    // 业务提额关闭（假提额流程）
    async bizLimitUpClose ({ commit }, params) {
      const response = await axios.post('/loan/v1/bizAdjustAmountClose', params)
      return response.data
    }
  }
}
